exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */\n/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */.hotel-image-container{width:100%;height:200px;position:relative;overflow:hidden}[dir] .hotel-image-container{margin:0}.hotel-image-container .hotel-image{min-width:150px;position:absolute;width:100%;height:100%;z-index:2}[dir] .hotel-image-container .hotel-image{background:50% no-repeat;background-size:cover;background-color:transparent}.hotel-image-container .image-default-svg-box{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;z-index:1;width:100%;height:100%}[dir] .hotel-image-container .image-default-svg-box{background-color:#97999b}.hotel-image-container .image-default-svg-box svg{fill:#fff;stroke:#fff;opacity:.7;height:75%}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/hotel-image/hotel-image.component.scss
// module id = ./src/main/webapp/stay-mgmt/app/components/hotel-image/hotel-image.component.scss
// module chunks = 0